import React from 'react';
import { Radio, Label } from 'flowbite-react';
import { TFunction } from 'i18next';

interface SelectionModeRadioButtonsProps {
  selectionMode: 'time' | 'prayer';
  handleSelectionChange: (mode: 'time' | 'prayer') => void;
  t: TFunction<'translation', undefined>;
}

export const SelectionModeRadioButtons: React.FC<
  SelectionModeRadioButtonsProps
> = ({ selectionMode, handleSelectionChange, t }) => (
  <div>
    <Label>{t('contentContext.selectPrayerTimeSettingMode')}</Label>
    <div className="mt-4 flex">
      <div className="me-4 flex items-center">
        <Radio
          id="set-time"
          name="selectionMode"
          value="time"
          checked={selectionMode === 'time'}
          onChange={() => handleSelectionChange('time')}
        />
        <Label htmlFor="set-time" className="ms-2">
          {t('contentContext.setTimeMode')}
        </Label>
      </div>
      <div className="me-4 flex items-center">
        <Radio
          id="select-prayer"
          name="selectionMode"
          value="prayer"
          checked={selectionMode === 'prayer'}
          onChange={() => handleSelectionChange('prayer')}
        />
        <Label htmlFor="select-prayer" className="ms-2">
          {t('contentContext.selectPrayerMode')}
        </Label>
      </div>
    </div>
  </div>
);
